<template>
  <div class="root">
    <div class="root-title">行业资讯</div>
    <div class="consult-view">
        <div class="left" style="flex:5;" >
            <div class="consult-banner">
                <el-carousel class="mid-banner" indicator-position="outside">
                    <el-carousel-item
                        v-for="(item,index) in bannerList"
                        class="banner-item"
                        :key="index"
                        :style="{
                        backgroundImage: 'url('+ item +')'
                        }">
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="mid" style="flex:4;" >
            <div class="hot-view">
                <div class="title">热门资讯</div>
                 <div class="hot-consult-view" v-for="(item, i) in consult.hot" :key="i">
                    <div class="dot"></div>
                    <div class="consult"  @click="toDetail(item.id)">{{item.title}}</div>
                 </div>
            </div>
            <div class="week-view">
                <div class="title">政策资讯</div>
                 <div class="hot-consult-view" v-for="(item, index) in consult.weekly" :key="index">
                    <div class="dot"></div>
                    <div class="consult"  @click="toDetail(item.id)">{{item.title}}</div>
                 </div>
            </div>
        </div>
        <div class="right" style="flex:6;">
            <div class="latest-view">
                <div class="title">最新资讯</div>
                 <div class="hot-consult-view" v-for="(item, index) in consult.latest" :key="index">
                    <div class="consult-left">
                        <div class="dot"></div>
                        <div class="consult"  @click="toDetail(item.id)">{{item.title}}</div>
                     </div>
                     <div class="consult-right">{{item.time}}</div>
                 </div>
            </div>
        </div>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <span>{{dialogTitle}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import {
    getConsultList
} from '@/api/home/consult.js'

export default {
  props: ['afterSaleList', 'page', 'total'],
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      bannerList: [
        '../../../static/image/index/03-01.jpg',
        '../../../static/image/index/03-02.jpg',
        '../../../static/image/index/03-03.jpg',
      ],
      consult: {
        hot: [
            {'title': '国产榴莲上市怎么回事'},
            {'title': '国产榴莲哪一年就有了'},
            {'title': '什么品种的榴莲好吃'},
            {'title': '缩二脲复合肥的优缺点'},
        ],
        weekly: [
            {'title': '是白菜但非白菜价，这两个新品种'},
            {'title': '大暑节气吃什么食物好'},
            {'title': '不一样的95后掘金千万'},
            {'title': '2023年第29周热搜农产品行情：龙眼上新'},
            {'title': '2023年中伏是几月几号？一共有几天'},
        ],
        latest: [
            {
                title: '复合肥是什么肥料？有什么优缺点？',
                time: '2023-07-26'
            }, {
                title: '苦瓜能生吃吗？苦瓜是凉性的还是热性的？',
                time: '2023-07-26'
            }, {
                title: '复合肥和有机肥有什么区别',
                time: '2023-07-26'
            }, {
                title: '丝瓜为什么会苦？',
                time: '2023-07-26'
            }, {
                title: '复合肥是什么肥料？有什么优缺点？',
                time: '2023-07-26'
            }, {
                title: '番茄切开里面的额籽是绿色的可以吃吗？',
                time: '2023-07-26'
            }, {
                title: '苦瓜能生吃吗？苦瓜是凉性的还是热性的？',
                time: '2023-07-26'
            }, {
                title: '复合肥和有机肥有什么区别',
                time: '2023-07-26'
            }, {
                title: '丝瓜为什么会苦？',
                time: '2023-07-26'
            }, {
                title: '国产榴莲从哪一年就有了？',
                time: '2023-07-26'
            }
        ]
      },
    }
  },
  mounted () {
    this.getConsultList()
  },
  methods: {
    async getConsultList () {
        // var _this = this
        // 类型 1热门咨询 2政策资讯 不传为全部 最新资讯就不用传
        let params = {
            'page': 1,
            'pageSize': 5,
            'type': 1
        }
        const response = await getConsultList(params)
        const res = response.data
        this.consult.hot = []
      if (res.code === '200') {
        res.data.list.forEach(item => {
            const pdata = {}
            pdata.title = item.title
            pdata.id = item.id

            this.consult.hot.push(pdata)
        })
      }

      let params1 = {
            'page': 1,
            'pageSize': 5,
            'type': 2
        }
        const response1 = await getConsultList(params1)
        const res1 = response1.data
        this.consult.weekly = []
      if (res1.code === '200') {
        res1.data.list.forEach(item => {
            const pdata = {}
            pdata.title = item.title
            pdata.id = item.id

            this.consult.weekly.push(pdata)
        })
      }

        let params2 = {
            'page': 1,
            'pageSize': 10
        }
        const response2 = await getConsultList(params2)
        const res2 = response2.data
        this.consult.latest = []
        if (res2.code === '200') {
            res2.data.list.forEach(item => {
                const pdata = {}
                pdata.title = item.title
                pdata.id = item.id

                this.consult.latest.push(pdata)
            })
        }
    },
    // 查看详情
    toDetail (item) {
        this.$router.push({
            path: '/consultDetail',
            query: {
                id: item
            }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.root{
  width: 100%;
  padding: 1px 8vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .root-title {
    height: 64px;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 0 16px;

    color: #222;
    font-size: 18px;
    font-weight: 700;
  }
  .consult-view {
    display: flex;
    flex-direction: row;
    margin-bottom: 12px;
    // border: 1px solid #e9e9e9;
    background-color: #fff;
    .left{
        display: flex;
        .consult-banner {
            height: 370;
            width: 100%;
            // background-color: #127614;
        }
    }
    .mid {
        display: flex;
        flex-direction: column;
        margin-left: 22px;
        .hot-view, .week-view {
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;
            .title {
                border-left: 4px solid #127614;
                padding-left:10px;
                color: #333;
                font-size: 14px;
                font-weight: 500;

                display: flex;
                align-items: center;
            }
            .hot-consult-view {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 15px;

                .dot {
                    width: 4px;
                    height: 4px;
                    border-radius: 2;
                    margin-right: 8px;
                    background-color: #666;
                }
                .consult{
                    color: #666;
                    font-size: 12px;
                    cursor: pointer;
                }
            }
        }
    }
    .right {
        display: flex;
        flex-direction: column;
        margin-left: 22px;

        .latest-view{
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;
            .title {
                border-left: 4px solid #127614;
                padding-left:10px;
                color: #333;
                font-size: 14px;
                font-weight: 500;

                display: flex;
                align-items: center;
            }
            .hot-consult-view {
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-top: 15px;
                padding-right: 15px ;
                box-sizing: border-box;
                justify-content: space-between;
                .consult-left {
                    display: flex;
                    align-items: center;
                    .dot {
                        width: 4px;
                        height: 4px;
                        border-radius: 2;
                        margin-right: 8px;
                        background-color: #666;
                    }
                    .consult{
                        color: #666;
                        font-size: 12px;
                        cursor: pointer;
                    }
                }
                .consult-right {
                    color:#666;
                    font-size: 12px;

                }
            }
        }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/consult.vue